angular.module('app.interface', [])
    .constant('INTERFACE', {
        
    });